import { ActionUTMType, StateUTMType } from '@src/types/UtmGenerator'
import { MapQueryName } from '@src/data/UtmGenerator'
import {
  GET_PROTOCOL,
  GET_LINK_PAGE,
  GET_SOURCE_TRAFFIC,
  GET_PARAMETERS,
  GET_TRANSLITERATION,
  GET_SHORT_LINK,
  GET_LOADING_SHORT_LINK,
  ERROR_SHORT_LINK
} from '@src/constants'

export function rootReducer(state: StateUTMType, action: ActionUTMType): StateUTMType {
  switch (action.type) {
    case GET_LINK_PAGE:
      return {
        ...state,
        linkPage: action.payload,
        valueShortLink: ''
      }
    case GET_PARAMETERS:
      return {
        ...state,
        [action.payload.name]: {
          ...state[action.payload.name],
          name: MapQueryName[action.payload.name],
          value: action.payload.value
        },
        valueShortLink: ''
      }
    case GET_PROTOCOL:
      return {
        ...state,
        protocol: action.payload,
        valueShortLink: ''
      }
    case GET_SOURCE_TRAFFIC:
      return {
        ...state,
        traffic: action.payload
      }
    case GET_TRANSLITERATION:
      return {
        ...state,
        transliteration: !state.transliteration,
        valueShortLink: ''
      }
    case GET_SHORT_LINK:
      return {
        ...state,
        valueShortLink: action.payload,
        loadingShortLink: false
      }
    case ERROR_SHORT_LINK:
      return {
        ...state,
        valueShortLink: action.payload,
        loadingShortLink: false,
        isErrorRequestShortLink: true
      }
    case GET_LOADING_SHORT_LINK:
      return {
        ...state,
        loadingShortLink: action.payload
      }
    default:
      return state
  }
}
